const accessMaster = {

    COUNTRY_LIST: { name: 'Country', path: '/country-list' },
    ADD_COUNTRY: { name: 'Add Country', path: '/create-country' },
    UPDATE_COUNTRY: { name: 'Update Country', path: '/edit-country' },
    DELETE_COUNTRY: { name: 'Delete Country', path: '/delete-country' },

    STATE_LIST: { name: 'State', path: '/state-list' },
    ADD_STATE: { name: 'Add State', path: '/create-state' },
    UPDATE_STATE: { name: 'Update State', path: '/edit-state' },
    DELETE_STATE: { name: 'Delete State', path: '/delete-state' },

    CITY_LIST: { name: 'City', path: '/city-list' },
    ADD_CITY: { name: 'Add City', path: '/create-city' },
    UPDATE_CITY: { name: 'Update City', path: '/edit-city' },
    DELETE_CITY: { name: 'Delete City', path: '/delete-city' },

    CHARGES_TYPE_LIST: { name: 'Charges Type', path: '/charges-type-list' },
    ADD_CHARGES_TYPE: { name: 'Add Charges Type', path: '/create-charges-type' },
    UPDATE_CHARGES_TYPE: { name: 'Update Charges Type', path: '/edit-charges-type' },
    DELETE_CHARGES_TYPE: { name: 'Delete Charges Type', path: '/delete-charges-type' },

    CHARGES: { name: 'Charges', path: '/charges' },

    CHECKLIST_LIST: { name: 'Checklist', path: '/checklist-list' },
    ADD_CHECKLIST: { name: 'Add Checklist', path: '/create-checklist' },
    UPDATE_CHECKLIST: { name: 'Update Checklist', path: '/edit-checklist' },
    DELETE_CHECKLIST: { name: 'Delete Checklist', path: '/delete-checklist' },

    SERVICE_TYPE_LIST: { name: 'Visitor Sub Type', path: '/service-type-list' },
    ADD_SERVICE_TYPE: { name: 'Add Visitor Sub Type', path: '/create-service-type' },
    UPDATE_SERVICE_TYPE: { name: 'Update Visitor Sub Type', path: '/edit-service-type' },
    DELETE_SERVICE_TYPE: { name: 'Delete Visitor Sub Type', path: '/delete-service-type' },

    SERVICE_SUB_TYPE_LIST: { name: 'Service Sub Type', path: '/service-sub-type-list' },
    ADD_SERVICE_SUB_TYPE: { name: 'Add Service Sub Type', path: '/create-service-sub-type' },
    UPDATE_SERVICE_SUB_TYPE: { name: 'Update Service Sub Type', path: '/edit-service-sub-type' },
    DELETE_SERVICE_SUB_TYPE: { name: 'Delete Service Sub Type', path: '/delete-service-sub-type' },

    DELIVERY_PARTNER_LIST: { name: 'Delivery Partner', path: '/delivery-partner-list' },
    ADD_DELIVERY_PARTNER: { name: 'Add Delivery Partner', path: '/create-delivery-partner' },
    UPDATE_DELIVERY_PARTNER: { name: 'Update Delivery Partner', path: '/edit-delivery-partner' },
    DELETE_DELIVERY_PARTNER: { name: 'Delete Delivery Partner', path: '/delete-delivery-partner' },

    EXPENSE_TYPE_LIST: { name: 'Expense Type', path: '/expense-type-list' },
    ADD_EXPENSE_TYPE: { name: 'Add Expense Type', path: '/create-expense-type' },
    UPDATE_EXPENSE_TYPE: { name: 'Update Expense Type', path: '/edit-expense-type' },
    DELETE_EXPENSE_TYPE: { name: 'Delete Expense Type', path: '/delete-expense-type' },

    NOTICE_TYPE_LIST: { name: 'Notice Type', path: '/notice-type' },
    ADD_NOTICE_TYPE: { name: 'Add Notice Type', path: '/create-notice-type' },
    UPDATE_NOTICE_TYPE: { name: 'Update Notice Type', path: '/edit-notice-type' },
    DELETE_NOTICE_TYPE: { name: 'Delete Notice Type', path: '/delete-notice-type' },

}

export default accessMaster;